import { AppThunk } from '@/store'
import { createAction, request } from '@/store/actions'

import {
  ADD_ACCOUNT_MANAGEMENT_CONNECTOR,
  CLEAR_ACCOUNT_MANAGEMENT_CONNECTOR_SECRET,
  CLEAR_SCIM_TOKEN_SECRET,
  DELETE_SCIM_TOKEN_KEY,
  GET_ACCOUNT_MANAGEMENT_CONNECTOR,
  GET_SCIM_TOKEN_KEY,
  REMOVE_ACCOUNT_MANAGEMENT_CONNECTOR
} from './actionTypes'

export const getAccountManagementConnector = (): AppThunk => {
  return dispatch => {
    return dispatch(
      request('/organizations/:organizationId/apiconnectors?type=scim', GET_ACCOUNT_MANAGEMENT_CONNECTOR, {
        method: 'GET'
      })
    )
  }
}

export const addAccountManagementConnector = (): AppThunk => {
  return dispatch => {
    return dispatch(
      request('/organizations/:organizationId/apiconnectors', ADD_ACCOUNT_MANAGEMENT_CONNECTOR, {
        method: 'POST',
        body: { type: 'scim' }
      })
    )
  }
}

export const deleteAccountManagementConnector = (accountManagementConnectorId: string): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        `/organizations/:organizationId/apiconnectors/${accountManagementConnectorId}`,
        REMOVE_ACCOUNT_MANAGEMENT_CONNECTOR,
        { method: 'DELETE' },
        { args: { accountManagementConnectorId } }
      )
    )
  }
}

export const deleteScimTokenKey = (webkeyId: string): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        `/organizations/:organizationId/webkeys/${webkeyId}`,
        DELETE_SCIM_TOKEN_KEY,
        { method: 'DELETE' },
        { args: { webkeyId } }
      )
    )
  }
}

export const getScimTokenKey = (): AppThunk => {
  return dispatch => {
    return dispatch(request('/organizations/:organizationId/webkeys', GET_SCIM_TOKEN_KEY, { method: 'GET' }))
  }
}

export const clearClientSecret = (accountManagementConnectorId: string): AppThunk => {
  return dispatch => {
    return new Promise(resolve => {
      resolve(dispatch(createAction(CLEAR_ACCOUNT_MANAGEMENT_CONNECTOR_SECRET, { accountManagementConnectorId })))
    })
  }
}

export function clearPrivateKey(webKeyInstanceId: string): AppThunk {
  return dispatch => {
    return new Promise(resolve => {
      resolve(dispatch(createAction(CLEAR_SCIM_TOKEN_SECRET, { webKeyInstanceId })))
    })
  }
}
